import logo from '../assets/logo.png';

function Navbar() {
  return (
    <div className="w-full bg-brand-dark px-4 py-2 flex items-center gap-2">
      <img src={logo} alt="NextGen Diani logo" className="h-8 w-8 object-contain" />
      <span className="text-brand-gold font-bold text-sm">NextGen Diani</span>
    </div>
  );
}

export default Navbar;